/** Google / Apple OAuth token — query (elsődleges) + hash (legacy) + sessionStorage (index.html bridge). */

const PENDING_KEY = "autopark_oauth_token";

export function extractOAuthTokenFromUrl() {
  if (typeof window === "undefined") return null;
  try {
    const q = new URLSearchParams(window.location.search);
    const fromQuery = q.get("auth_token");
    if (fromQuery) return fromQuery;
  } catch {
    /* ignore */
  }
  const hash = window.location.hash || "";
  const m = hash.match(/auth_token=([^&]+)/);
  if (m) return decodeURIComponent(m[1]);
  return null;
}

export function consumePendingOAuthToken() {
  let token = extractOAuthTokenFromUrl();
  if (token) return token;
  try {
    token = sessionStorage.getItem(PENDING_KEY);
    if (token) sessionStorage.removeItem(PENDING_KEY);
  } catch {
    /* ignore */
  }
  return token;
}

export function clearOAuthTokenFromAddressBar() {
  if (typeof window === "undefined") return;
  const path = window.location.pathname || "/google/vissza";
  try {
    window.history.replaceState(null, "", path);
  } catch {
    /* ignore */
  }
}

export function isOAuthCallbackPath(pathname = "") {
  return pathname === "/google/vissza" || pathname === "/apple/vissza";
}
